(ns iris.data.protocol
  "Data access protocol for abstracting Firebase and WebSocket implementations.
   
   This protocol defines all data operations needed by Iris.
   Implementations provide concrete behavior for Firebase or WebSocket/Redis.")

(defprotocol IDataSource
  "Protocol for data access operations"
  
  ;; Raids
  (set-raid2eid [this abbr eid] "Map raid abbreviation to entity ID")
  (get-raid2eid [this abbr] "Get entity ID for raid abbreviation. Returns promise.")
  (get-eid2raid [this eid] "Get raid abbreviation for entity ID. Returns promise.")
  (reset-eid2raid [this] "Clear all eid to raid mappings")
  (reset-raid2eid [this] "Clear all raid to eid mappings")
  (reset-raid-cache-id [this] "Reset raid cache ID with current timestamp")
  
  ;; Views
  (get-nviews [this ruids]
    "Get nviews for a list of ruids. Returns promise resolving to {ruid -> nviews}.")

  ;; Votes
  (get-post-votes [this ws forum thread nick on-update-handler] 
    "Get vote counts for a post. Calls on-update-handler with result.")
  (get-post-votes-promise [this ws forum thread nick]
    "Get vote counts for a post. Returns promise.")
  
  ;; Replies
  (get-replies [this ws thread on-update-handler]
    "Get reply count and timestamp. Calls on-update-handler with result.")
  (get-replies-promise [this ws thread]
    "Get reply count and timestamp. Returns promise.")
  (get-replies-t-promise [this ws thread]
    "Get reply timestamp only. Returns promise.")
  
  ;; Shares
  (get-shares-promise [this ws share-page-kind ruid]
    "Get share counts. Returns promise.")
  
  ;; Admin - Votes & Shares Logs
  (push-admin-votes-log [this data] "Log admin vote action")
  (push-admin-shares-log [this data] "Log admin share action")
  
  ;; Thread Alerts
  (set-thread-follow [this data] "Set thread follow/alert")
  (remove-thread-follow [this id] "Remove thread follow/alert")
  (set-thread-follow-t [this id t] "Update thread follow timestamp")
  (get-thread-follow-promise [this id] "Get thread follow data. Returns promise.")
  (get-all-thread-follow-promise [this uid] "Get all thread follows for user. Returns promise.")
  
  ;; User Defaults
  (set-defaults-ws [this ws] "Set default workspace")
  (get-defaults-ws-promise [this] "Get default workspace. Returns promise.")
  (get-default-ws-with-fallback [this default] "Get default workspace with fallback. Returns promise.")
  
  ;; User Actions
  (set-last-action [this data] "Record last user action")
  
  ;; Moderation Logs
  (push-admin-all-moderation-log [this data] "Push to all-users moderation log")
  (push-admin-moderation-log [this data] "Push to personal moderation log")
  (get-admin-moderation-logs-promise [this ws uid] "Get personal moderation logs. Returns promise.")
  (get-admin-all-moderation-logs-promise [this ws ruid] "Get all-users moderation logs. Returns promise."))
